export const STYLE_MAP = {
  red: {
    backgroundColor: '#FF5000'
  },
  yellow: {
    backgroundColor: '#FFC900'
  },
  white: {
    backgroundColor: '#FFFFFF',
    borderColor: '#A5A5A5',
    borderWidth: '1px'
  },
  blue: {
    backgroundColor: '#0F8DE8'
  },
  green: {
    backgroundColor: '#19be6b'
  }
};

export const TEXT_STYLE_MAP = {
  red: {
    color: '#FFFFFF'
  },
  yellow: {
    color: '#FFFFFF'
  },
  blue: {
    color: '#FFFFFF'
  },
  white: {
    color: '#3D3D3D'
  },
  green: {
    color: '#FFFFFF'
  }
};

export const BUTTON_STYLE_MAP = {
  full: {
    width: '100%',
  },
  big: {
    width: '80%',
  },
  medium: {
    width: '60%',
  },
  small: {
    width: '40%',
  }
}

export const TEXT_FONTSIZE_STYLE_MAP = {
  full: {
    fontSize: '16px'
  },
  big: {
    fontSize: '15px'
  },
  medium: {
    fontSize: '14px'
  },
  small: {
    fontSize: '13px'
  }
};
